import * as React from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import {
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useGetDmsShopifyLocationsQuery } from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { ShippingContextType, ShipProfileContext } from "./ShippingProfile";
import { Console } from "console";

interface ProfileNameProps {
  handleNext: any;
  handleBack: any;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ShippingFrom: React.FunctionComponent<ProfileNameProps> = ({
  handleBack,
  handleNext,
}) => {
  const { data, isLoading } = useGetDmsShopifyLocationsQuery({});
  const [shopifyLocations, setshopifyLocations] = React.useState<any>([]);

  const { profile, setProfile } = React.useContext(
    ShipProfileContext
  ) as ShippingContextType;
  const [selectedLocations, setSelectedLocations] = React.useState<any>(
    profile.locationGroupsToCreate
      ? profile.locationGroupsToCreate[0].locations
      : []
  );

  React.useEffect(() => {
    if (data) {
      setshopifyLocations(data?.entityList);
    }
  }, [data]);

  const handlContinue = () => {
    setProfile({
      ...profile,
      locationGroupsToCreate: profile?.locationGroupsToCreate
        ? [
            ...profile?.locationGroupsToCreate,
            {
              locations: selectedLocations,
              // zonesToCreate: profile.locationGroupsToCreate
              //   ? profile.locationGroupsToCreate[0].zonesToCreate
              //   : undefined,
            },
          ]
        : [
            {
              locations: selectedLocations,
            },
          ],
    });

    handleNext();
  };

  React.useEffect(() => {
    console.log("Context Data", profile);
  }, [profile]);

  return (
    <>
      <Container maxWidth="md">
        <Box
          sx={{ display: "flex" }}
          height="60vh"
          style={{ placeContent: "center" }}
        >
          <FormControl
            sx={{ m: 1 }}
            component="fieldset"
            variant="standard"
            style={{ alignItems: "center" }}
          >
            <FormLabel component="h2" style={{ fontSize: "1.5rem" }}>
              Select Locations to ship from
            </FormLabel>
            {isLoading ? (
              <CircularProgress size="1.2rem" color="inherit" />
            ) : (
              <FormGroup>
                {shopifyLocations.map((item: any) => {
                  return (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedLocations.some(
                              (i: any) => i == item.id
                            )}
                            onChange={(e) => {
                              console.log(e);
                              if (e.target.checked) {
                                setSelectedLocations([
                                  ...selectedLocations,
                                  item.id,
                                ]);
                              } else {
                                setSelectedLocations(
                                  selectedLocations.filter(
                                    (loc: any) => loc !== item.id
                                  )
                                );
                              }
                            }}
                            name={item.name}
                          />
                        }
                        label={item.name}
                      />
                    </>
                  );
                })}
              </FormGroup>
            )}
          </FormControl>
        </Box>
      </Container>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button onClick={handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
        <Button
          onClick={handlContinue}
          disabled={selectedLocations.length === 0}
        >
          Next
        </Button>
      </Box>
    </>
  );
};

export default ShippingFrom;
